import apiService from "@/webapi/api/api_service"
import slackService from "@/webapi/api/slack_service"
import adminService from "@/webapi/api/admin_service"

export default {
  apiService,
  slackService,
  adminService
};
